import config from "@/libs/config";
import type Rollbar from "rollbar";

/**
 * Configuration object for the Rollbar error tracking service.
 * deital: https://docs.rollbar.com/docs/rollbarjs-configuration-reference
 * @type {Rollbar.Configuration}
 */
const rollbarConfig: Rollbar.Configuration = {
  accessToken: "7819160bd1c24ded9f080f8e001fcb16",
  captureUncaught: true,
  captureUnhandledRejections: true,
  logLevel: config.IS_PROD ? "info" : "debug",
  reportLevel: config.IS_PROD ? "info" : "debug",
  addErrorContext: true,
  payload: {
    environment: config.ROLLBAR_ENV,
    custom: {
      bankCode: config.BANK_CODE,
    },
    client: {
      javascript: {
        source_map_enabled: config.BANK_NAME === "mfbank",
        code_version: config.ROLLBAR_CODE_VERSION,
        guess_uncaught_frames: true,
      },
    },
  },
  autoInstrument: {
    network: true,
    log: false,
    dom: true,
    navigation: true,
    connectivity: true,
    contentSecurityPolicy: true,
    errorOnContentSecurityPolicy: false,
  },
  scrubTelemetryInputs: false,
  enabled: config.ROLLBAR_ENABLED,
  scrubFields: [
    // company
    "lastName",
    "lastNameKana",
    "middleName",
    "middleNameKana",
    "firstName",
    "firstNameKana",
    "email",
    // company info
    "representativeName",
    "representativeEmailAddress",
    "mainUserName",
    "mainUserPhoneNumber",
    // bizsol
    "userName",
    // etc
    "password",
    "access_token",
    "id_token",
    "refresh_token",
    "token",
    "registrationToken",
  ],
};

export default rollbarConfig;
